export default {
  total: '共 {total} 条',
  page_size: '{size} 条/页',
  goTo: '跳转到',
  page: '页',
};
